<div class="dialog_main">
  <button type="button" class="dialog_close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'UploadDocument' | translate }}</h2>
      <p>{{'Onceyouvesharedyourdetailshere' | translate}}</p>
    </div>

    <form [formGroup]="uploadFormGroup" (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        <ng-container formArrayName="documents">
          @for (item of getDocuments.controls; track item) {
            <ng-container [formGroupName]="$index">
              <div class="form_group w_100">
                <mat-label>
                  <strong>
                    {{ item.get('name')?.value }}
                  </strong>
                </mat-label>
              </div>

              @if (item.get('issueDateRequire')?.value) {
                <div class="form_group w_50">
                  <mat-label>{{ 'IssueDate' | translate }}</mat-label>
                  <mat-form-field appearance="fill">
                    <input
                      readonly
                      [max]="yesterday"
                      matInput
                      [matDatepicker]="picker"
                      formControlName="issueDate"
                      placeholder="DD/MM/YYYY"
                      class="form_control" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker">
                      <img
                        matDatepickerToggleIcon
                        [src]="assetsConst.calender_icon"
                        alt="Icon" />
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <ng-container *ngTemplateOutlet="issueDateValidator">
                  </ng-container>
                </div>
              }

              @if (item.get('expiryDateRequire')?.value) {
                <div class="form_group w_50">
                  <mat-label>{{ 'ExpireDate' | translate }}</mat-label>
                  <mat-form-field appearance="fill">
                    <input
                      readonly
                      [min]="tomorrow"
                      matInput
                      [matDatepicker]="picker1"
                      formControlName="expiryDate"
                      placeholder="DD/MM/YYYY"
                      class="form_control" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker1">
                      <img
                        matDatepickerToggleIcon
                        [src]="assetsConst.calender_icon"
                        alt="Icon" />
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                  <ng-container *ngTemplateOutlet="expiryDateValidator">
                  </ng-container>
                </div>
              }

              <div class="form_group w_100" style="margin: 0"></div>

              @if (item.get('frontImageRequire')?.value) {
                <div class="form_group typeInput w_50 doc-upload">
                  <mat-label>{{ 'FrontSide' | translate }}</mat-label>
                  <label class="upload_box v2" for="upload">
                    @if (item.get('frontImage')?.value) {
                      <div class="preview">
                        <figure>
                          <img
                            [src]="item.get('frontImage')?.value"
                            alt="adminProfile" />
                        </figure>
                      </div>
                    } @else {
                      <mat-icon>add</mat-icon>
                    }
                    <input
                      type="file"
                      class="form_control"
                      accept="image/*"
                      (change)="
                        ondynamicDocsImageChange($event, $index, 'frontImage')
                      " />
                  </label>
                  <ng-container *ngTemplateOutlet="frontImageValidator">
                  </ng-container>
                </div>
              }

              @if (item.get('backImageRequire')?.value) {
                <div class="form_group typeInput w_50 doc-upload">
                  <mat-label>{{ 'BackSide' | translate }}</mat-label>
                  <label class="upload_box v2" for="upload">
                    @if (item.get('backImage')?.value) {
                      <div class="preview">
                        <figure>
                          <img
                            [src]="item.get('backImage')?.value"
                            alt="adminProfile" />
                        </figure>
                      </div>
                    } @else {
                      <mat-icon>add</mat-icon>
                    }
                    <input
                      type="file"
                      class="form_control"
                      accept="image/*"
                      (change)="
                        ondynamicDocsImageChange($event, $index, 'backImage')
                      " />
                  </label>
                  <ng-container *ngTemplateOutlet="backImageValidator">
                  </ng-container>
                </div>
              }
            </ng-container>

            <ng-template #frontImageValidator>
              @if (submitted) {
                @if (
                  getDocuments.controls[$index]
                    .get('frontImage')
                    ?.hasError('required')
                ) {
                  <mat-error>
                    {{ 'FrontSide' | translate }} {{ 'IsRequired' | translate }}
                  </mat-error>
                }
              }
            </ng-template>

            <ng-template #backImageValidator>
              @if (submitted) {
                @if (
                  getDocuments.controls[$index]
                    .get('backImage')
                    ?.hasError('required')
                ) {
                  <mat-error>
                    {{ 'BackSide' | translate }} {{ 'IsRequired' | translate }}
                  </mat-error>
                }
              }
            </ng-template>

            <ng-template #issueDateValidator>
              @if (submitted) {
                @if (
                  getDocuments.controls[$index]
                    .get('issueDate')
                    ?.hasError('required')
                ) {
                  <mat-error>
                    {{ 'IssueDate' | translate }} {{ 'IsRequired' | translate }}
                  </mat-error>
                }
              }
            </ng-template>

            <ng-template #expiryDateValidator>
              @if (submitted) {
                @if (
                  getDocuments.controls[$index]
                    .get('expiryDate')
                    ?.hasError('required')
                ) {
                  <mat-error>
                    {{ 'ExpireDate' | translate }}
                    {{ 'IsRequired' | translate }}
                  </mat-error>
                }
              }
            </ng-template>
          }
        </ng-container>
      </div>

      <div class="form_btn text_center">
        <button
          class="btn btn_primary"
          type="submit
        ">
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
